<template>
	<div id="page" v-cloak>
		<mescroll-vue ref="mescroll" :up="mescrollUp" @init="mescrollInit">
			<ul class="friend_list">
				<li class="clear" v-for="(item,index) in dataList">
					<img class="friend_icon lt" :src="icon_path+item.icon_name" alt="">
					<div class="friend_info lt">
						<p class="friend_name">{{item.nick_name}}</p>
						<p class="friend_date">{{item.last_time}}</p>
					</div>
					<div class="friend_award rt">
						<p>+{{item.total_coins_to_parent}}银币</p>
						<p>+{{item.total_diamonds_to_parent}}钻石</p>
					</div>
				</li>
			</ul>  
			<div id="warpId"></div>
		</mescroll-vue>
		<input class="invite_friend_btn" type="button" value="邀请好友赚佣金" @click="openUrl(2)">
	</div>
</template>

<script>
	import MescrollVue from 'mescroll.js/mescroll.vue'
	export default {
		name: 'ProfitDetails',
		components: {
		  MescrollVue // 注册mescroll组件
		},
		data() {
			return {
				userId: '',
				H5Key: '',
				md5: '',
				icon_path: '',
				mescroll: null, // mescroll实例对象
				mescrollUp: { // 上拉加载的配置.
				    callback: this.upCallback, // 上拉回调,此处简写; 相当于 callback: function(page, mescroll) { }
				    htmlNodata: '<p class="upwarp-nodata">-- 已经到底了 --</p>',
				    toTop: {
				      //回到顶部按钮
				      src: "http://dig-mineral.yeedian365.com/taobao_union/img/mescroll-totop.png", //图片路径,默认null,支持网络图
				      offset: 1000 //列表滚动1000px才显示回到顶部按钮
				    },
				    empty: {
				      //列表第一页无任何数据时,显示的空提示布局; 需配置warpId才显示
				      warpId: "warpId", //父布局的id (1.3.5版本支持传入dom元素)
				      icon: "http://dig-mineral.yeedian365.com/taobao_union/img/mescroll-empty.png", //图标,默认null,支持网络图
				      tip: "暂无相关数据~" //提示
				    }
				},
				dataList: [], // 列表数据
			}
		},
		mounted() {
			if(window.LaiaJs){
				window.LaiaJs.setTitle('好友列表');
				this.userId = window.LaiaJs.getUserId();
				this.H5Key = window.LaiaJs.getH5Key();
				this.md5 = this.$md5(this.H5Key);
			}else{
				this.userId = '090405e138b74c9f9ceb397f42633c06';
				this.H5Key = 'PyPtPu4qSx1wTBYEYB4ASyWETrVsSBPv';
				this.md5 = this.$md5(this.H5Key);
			}
		},
		methods: {
			// mescroll组件初始化的回调,可获取到mescroll对象
			mescrollInit (mescroll) {
			  this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
			},
			upCallback(page, mescroll) {
			  //联网请求
			  this.$axios.post("/user/getFriendList.do",  {
			    "user_id": this.userId,
				"sign": this.md5,
			  }).then((res)=> {
			    // console.log(res);
				if(res.data.Error != ""){
					if(window.LaiaJs){
						window.LaiaJs.showMsg(res.data.Error);
						return;
					}else{
						alert(res.data.Error);
						return;
					}
				}
			    //请求的列表数据
				this.icon_path = res.data.icon_path;
			  var list = res.data.friendList;
				if (page.num == 1) this.dataList = [];
				//把请求到的数据添加到列表
				this.dataList = this.dataList.concat(list);
				//数据渲染成功后,隐藏下拉刷新的状态
				this.$nextTick(() => {
				  this.mescroll.endSuccess(list.length);
				})
			  }).catch((e)=> {
			    //联网失败的回调,隐藏下拉刷新和上拉加载的状态;
			    this.mescroll.endErr();
			  })
			},
			// 跳转页面
			openUrl() {
				if(window.LaiaJs){
					window.LaiaJs.showShareCard();
				}
			},
		}
	}
</script>

<style scoped>
	[v-cloak] {
		display: none;
	}
	#page {
		width: 100%;
		height: 100vh;
		background-color: #eaf1f7;
	}
	.friend_list{
		width: 100%;
		height: auto;
	}
	.friend_list li{
		background-color: #fff;
		padding: 0.24rem 0.48rem;
		border-bottom: 1px solid #dce0e6;
	}
	.friend_icon{
		width: 1.2rem;
		height: 1.2rem;
		border-radius: 0.6rem;
	}
	.friend_info,.friend_award{
		font-size: 0.3rem;
		line-height: 0.6rem;
		margin-left: 0.26rem;
	}
	.friend_name{
		font-size: 0.36rem;
		color: #41465c;
	}
	.friend_date{
		font-size: 0.3rem;
		color: #8a8e95;
	}
	.friend_award p:first-child{
		color: #ffa810;
	}
	.friend_award p:last-child{
		color: #2e74fb;
	}
	.invite_friend_btn{
		width: 8.8rem;
		height: 1.26rem;
		font-size: 0.4rem;
		color: #fff;
		letter-spacing: 1px;
		border-radius: 0.1rem;
		background: #3672f9;
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0.42rem;
		margin: 0 auto;
	}
</style>



// WEBPACK FOOTER //
// src/pages/FriendList.vue